const UserActivitySummaryViewModelKeysTypeName = "UserActivitySummaryViewModelKeys";
const UserActivitySummaryQueryFieldsTypeName = "UserActivitySummaryQueryFields";
export {
  UserActivitySummaryQueryFieldsTypeName,
  UserActivitySummaryViewModelKeysTypeName
};
//# sourceMappingURL=constants.js.map
